/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EnumItem4 } from './EnumItem4';
import {
    EnumItem4FromJSON,
    EnumItem4FromJSONTyped,
    EnumItem4ToJSON,
    EnumItem4ToJSONTyped,
} from './EnumItem4';
import type { AdminBillItem1 } from './AdminBillItem1';
import {
    AdminBillItem1FromJSON,
    AdminBillItem1FromJSONTyped,
    AdminBillItem1ToJSON,
    AdminBillItem1ToJSONTyped,
} from './AdminBillItem1';

/**
 * 
 * @export
 * @interface AdminBillListVo
 */
export interface AdminBillListVo {
    /**
     * 当前页
     * @type {number}
     * @memberof AdminBillListVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof AdminBillListVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof AdminBillListVo
     */
    totalRecord?: number;
    /**
     * 账单记录列表
     * @type {Array<AdminBillItem1>}
     * @memberof AdminBillListVo
     */
    records?: Array<AdminBillItem1>;
    /**
     * 账单类型列表
     * @type {Array<EnumItem4>}
     * @memberof AdminBillListVo
     */
    billTypeList?: Array<EnumItem4>;
    /**
     * 账单状态列表
     * @type {Array<EnumItem4>}
     * @memberof AdminBillListVo
     */
    statusList?: Array<EnumItem4>;
    /**
     * 卡类型列表
     * @type {Array<EnumItem4>}
     * @memberof AdminBillListVo
     */
    cardTypeList?: Array<EnumItem4>;
}

/**
 * Check if a given object implements the AdminBillListVo interface.
 */
export function instanceOfAdminBillListVo(value: object): value is AdminBillListVo {
    return true;
}

export function AdminBillListVoFromJSON(json: any): AdminBillListVo {
    return AdminBillListVoFromJSONTyped(json, false);
}

export function AdminBillListVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminBillListVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(AdminBillItem1FromJSON)),
        'billTypeList': json['billTypeList'] == null ? undefined : ((json['billTypeList'] as Array<any>).map(EnumItem4FromJSON)),
        'statusList': json['statusList'] == null ? undefined : ((json['statusList'] as Array<any>).map(EnumItem4FromJSON)),
        'cardTypeList': json['cardTypeList'] == null ? undefined : ((json['cardTypeList'] as Array<any>).map(EnumItem4FromJSON)),
    };
}

export function AdminBillListVoToJSON(json: any): AdminBillListVo {
    return AdminBillListVoToJSONTyped(json, false);
}

export function AdminBillListVoToJSONTyped(value?: AdminBillListVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(AdminBillItem1ToJSON)),
        'billTypeList': value['billTypeList'] == null ? undefined : ((value['billTypeList'] as Array<any>).map(EnumItem4ToJSON)),
        'statusList': value['statusList'] == null ? undefined : ((value['statusList'] as Array<any>).map(EnumItem4ToJSON)),
        'cardTypeList': value['cardTypeList'] == null ? undefined : ((value['cardTypeList'] as Array<any>).map(EnumItem4ToJSON)),
    };
}

